import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';

import { DatePipe } from '@angular/common'

element: HTMLImageElement;
declare var $: any;

@Component({
  selector: 'app-upload-nric',
  templateUrl: './upload-nric.component.html',
  styleUrls: ['./upload-nric.component.scss']
})
export class UploadNRICComponent implements OnInit {
  FlowDetails: any
  // nricDetails: FormGroup;
  firstDirector = {
    Name: '',
    NRIC: '',
    frontSideFileExt: '',
    frontSideCapturedValue: '',
    frontSideUploadedDate: '',
    backSideFileExt: '',
    backSideCapturedValue: '',
    backSideUploadedDate: ''
  };
  InitialLoad: boolean;
  directorName: any;
  currentDate = new Date();
  isEditMode: boolean = false;
  FlowDet: string;
  constructor(public router: Router,
    private connectRestService: ConnectRestService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute) {
    var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader)
    this.FlowDetails = ServiceHeader.Flow
  }
  ngOnInit() {
    // this.nricDetails = this.formBuilder.group({
    //    frontSideOfNRIC: ['', Validators.required],
    //    backSideOfNRIC: ['', Validators.required],
    //   })
    // this.firstDirector.Name = JSON.parse(sessionStorage.getItem('firstDirector')).Name;
    // this.firstDirector.NRIC = JSON.parse(sessionStorage.getItem('firstDirector')).NRIC;
    this.firstDirector.frontSideUploadedDate = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy HH:mm:ss a');
    this.firstDirector.backSideUploadedDate = this.datePipe.transform(this.currentDate, 'dd/MM/yyyy HH:mm:ss a');
    const _this = this;
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    var ServiceHeader = JSON.parse(sessionStorage.ServiceHeader);
    this.FlowDet = ServiceHeader.Flow;
    this.getRequest();
    this.InitialLoad = true;


    // console.log("test");
    $(document).ready(function () {
      $("#obaoform").validate({
        rules: {
          upload_front: {
            required: this.InitialLoad == true ? true : false,
            extension: "jpg|jpeg",
            // maxsize: 5000000
          },
          upload_back: {
            required: this.InitialLoad == true ? true : false,
            extension: "jpg|jpeg",
            // maxsize: 5000000
          }
        },
        messages: {
          upload_front: {
            required: "Please select an image",
            extension: "Please select an image with format .jpg or .jpeg",
            // maxsize: "File size must not exceed 5Mb each. On your camera application, go to Setting and to select lower resolutions"
          },
          upload_back: {
            required: "Please select an image",
            extension: "Please select an image with format .jpg or .jpeg",
            // maxsize: "File size must not exceed 5Mb each. On your camera application, go to Setting and to select lower resolutions"
          }
        },
        errorPlacement: function (error, element) {

          if (element.attr("name") == "upload_front") {
            error.appendTo($("#upload_front_error_container"));
          }

          if (element.attr("name") == "upload_back") {
            error.appendTo($("#upload_back_error_container"));
          }
        },
        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }
      });
    });

    /*       $("#upload_front").change(function () {
            $("#upload_front").valid();
          })
          $("#upload_back").change(function () {
            $("#upload_back").valid();
          }) */

    $('#thumbnail-container-ic-f').addClass("hidden")
    $('#thumbnail-container-ic-b').addClass("hidden")

    /*   DCI update (16th June 2020) : Add javascript for thumbnail image start*/
    function handleFileSelect(evt) {
      _this.connectRestService.showLoader()
      if (evt.target.files.length > 0) {
        var files = evt.target.files;
        var fileName = files.item(0).name;
        var filesize = files[0].size;//check filesize
        var maxsize = 5000000;//5mb maxsize
        var ext = fileName.split(".").pop();
      // console.log("Current file size:" + filesize + 'bytes');
      // console.log(fileName);
        // Declare variable of the id of changed input files 
        var id = $(this).attr('id');
        // console.log(id);
        if (id === 'upload_front') {
          _this.firstDirector.frontSideFileExt = ext;
          // console.log("pop:" + ext);
          // console.log("size:" + filesize);
        } else if (id == 'upload_back') {
          _this.firstDirector.backSideFileExt = ext;
          // console.log("pop:" + ext);
          // console.log("size:" + filesize);
        }
        // Declare the id of image to be replace it source
        var upload_to_front = 'thumbnail-container-ic-f';
        var upload_to_back = 'thumbnail-container-ic-b';
        // Loop through the FileList and render image files as thumbnails.
        for (var i = 0, f; f = files[i]; i++) {
          // Only process image files.
          // if (!f.type.match('image.*')) {
          //   continue;
          // }
          var reader = new FileReader();
          // Closure to capture the file information.
          evt.stopPropagation();
          reader.onload = (function (theFile) {
            return function (e) {
              // console.log(id);
              // Render thumbnail.
              if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg"))) {
              if (id == "upload_front") {
                //image resizing
                $.canvasResize(theFile, {
                  width: 500,
                  height: 0,
                  crop: false,
                  quality: 100,
                  callback: function (data) {
                    //show image thumbnail
                    // if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg")) && filesize <= maxsize) {
                    if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg"))) {
                      var f = $.canvasResize('dataURLtoBlob', data);
                      // console.log("Resized file size:" + f.size + 'bytes');
                      $('#' + upload_to_front).attr('src', data);
                      // $('#' + upload_to_front).css("height", "auto");
                      $('#' + upload_to_front).css({ "height": "auto", "width": "auto", "max-width": "229px", "max-height": "200px" });
                      $('#file_text_1').text("Re-upload");
                      // console.log(data);

                      /*   DCI update (16th June 2020) : Data below is base64 string data for image*/
                      $('#output_upload_front').val(data);
                      $('#thumbnail-container-ic-f').removeClass("hidden")
                      _this.connectRestService.hideLoader()
                    } else {
                      $('#' + upload_to_front).attr('src', '');
                      $('#' + upload_to_front).css("height", "0px");
                      _this.connectRestService.hideLoader()
                    }
                  }
                });
              } else if (id == 'upload_back') {
                //image resizing
                $.canvasResize(theFile, {
                  width: 500,
                  height: 0,
                  crop: false,
                  quality: 100,
                  callback: function (data) {
                    //show image thumbnail
                   // if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg")) && filesize <= maxsize) {
                   if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg"))) {
                    var f = $.canvasResize('dataURLtoBlob', data);
                   //  console.log("Resized file size:" + f.size + 'bytes');
                      $('#' + upload_to_back).attr('src', data);
                      // $('#' + upload_to_back).css("height", "auto");
                      $('#' + upload_to_back).css({ "height": "auto", "width": "auto", "max-width": "229px", "max-height": "200px" });

                      $('#file_text_2').text("Re-upload");
                      // console.log(data);
                      /*   DCI update (16th June 2020) : Data below is base64 string data for image*/
                      $('#output_upload_back').val(data);
                      $('#thumbnail-container-ic-b').removeClass("hidden")
                      _this.connectRestService.hideLoader()
                    }
                    else {
                      $('#' + upload_to_back).attr('src', '');
                      $('#' + upload_to_back).css("height", "0px");
                      _this.connectRestService.hideLoader()
                    }
                  }
                });
              }
            } else {
              if (id == "upload_front") {
                $('#thumbnail-container-ic-f').attr('src','');
              } else if (id == 'upload_back') {
                $('#thumbnail-container-ic-b').attr('src','');
              }
              $('#' + id).css("height", "0px");
              _this.connectRestService.hideLoader()
            }
        
            };
          })(f);
          // Read in the image file as a data URL.
          reader.readAsDataURL(f);
        }
      } else {
        evt.stopPropagation();
        _this.connectRestService.hideLoader()
      }
    }
    document.getElementById('upload_front').addEventListener('change', handleFileSelect, false);
    document.getElementById('upload_back').addEventListener('change', handleFileSelect, false);
    /*   DCI update (16th June 2020) : Add javascript for thumbnail image end*/
    $("#upload_front").on('change', function () {
      $("#upload_front").valid();
    })
    $("#upload_back").on('change', function () {
      $("#upload_back").valid();
    })
    $(document).change(function () {
      $("#obaoform").valid();
    })

  }
  async getRequest() {
    let caseID = JSON.parse(sessionStorage.getItem('ServiceHeader')).CaseID;
    if (caseID) {
      var data = {
        "ApplicantList": [{
          "NRIC": this.firstDirector.NRIC,
          "Name": this.firstDirector.Name,
        }
        ]
      };
      var ServResponse = await this.connectRestService.connectRest(data, "R0080", '');
      if (ServResponse.Status == "Success") {
        // this.setData(ServResponse);
        this.InitialLoad = false;
        this.directorName = ServResponse['ApplicantList'][0].Name;
        const data = ServResponse['ApplicantList'] && ServResponse['ApplicantList'][0] &&
          ServResponse['ApplicantList'][0].CapturedDocuments;
        if (data) {
          const settings = $("#obaoform").validate().settings;
          for (let i in settings.rules) {
            delete settings.rules[i].required;
          }
          $('#thumbnail-container-ic-b').removeClass("hidden")
          $('#thumbnail-container-ic-f').removeClass("hidden")
          $('.thumbnail-img').css("width", "auto");
          for (let document of data) {
            if (document.Type === 'NRICFront') {
              this.firstDirector.frontSideCapturedValue = document.Value;
              this.firstDirector.frontSideFileExt = document.ExtensionType;
              this.firstDirector.frontSideUploadedDate = document.Time;
              $('#thumbnail-container-ic-f').attr('src', document.Value);
              $('#file_text_1').text("Re-upload");
              $('#output_upload_front').val(document.Value);
              $('#thumbnail-container-ic-f').css({ "height": "auto", "width": "auto", "max-width": "229px", "max-height": "200px" });
            } else if (document.Type === 'NRICBack') {
              this.firstDirector.backSideCapturedValue = document.Value,
                this.firstDirector.backSideFileExt = document.ExtensionType,
                this.firstDirector.backSideUploadedDate = document.Time
              $('#thumbnail-container-ic-b').attr('src', document.Value);
              $('#file_text_2').text("Re-upload");
              $('#output_upload_back').val(document.Value);
              $('#thumbnail-container-ic-b').css({ "height": "auto", "width": "auto", "max-width": "229px", "max-height": "200px" });
            }
          }
        }
      }
      else {
        // console.log("Server Response: " + ServResponse.Status);
      }

    }
  }

  public onSubmit() {
    this.firstDirector.frontSideCapturedValue = $('#thumbnail-container-ic-f').attr('src');
    this.firstDirector.backSideCapturedValue = $('#thumbnail-container-ic-b').attr('src');
    if ($("#obaoform").valid()) {
      const serviceBody = {
        "ApplicantList": [{
          "NRIC": this.firstDirector.NRIC,
          "Name": this.firstDirector.Name,

          "CapturedDocuments": [{
            "Time": this.firstDirector.frontSideUploadedDate,
            "Type": "NRICFront",
            "Value": this.firstDirector.frontSideCapturedValue, // split(';base64,')[1],
            "ExtensionType": this.firstDirector.frontSideFileExt,
          }, {
            "Time": this.firstDirector.backSideUploadedDate,
            "Type": "NRICBack",
            "Value": this.firstDirector.backSideCapturedValue, //split(';base64,')[1],
            "ExtensionType": this.firstDirector.backSideFileExt
          }
          ],
        }
        ]
      };
      this.restConnect(serviceBody);
    }
  }

  // method for update api
  public async restConnect(data) {
    const RequestID = 'S0080';
    const responseData = await this.connectRestService.connectRest(data, RequestID, '')
    if (responseData.Status === 'Success') {
      if (!this.isEditMode) {
        this.router.navigate(['/signature']);
      } else {
        this.router.navigate(['/director-confirm']);
      }
    } else {
      //  console.log("Server Response: " + responseData.Status);
    }
  }

  onPrevious() {
 
    if (this.FlowDetails == '1') {
      this.router.navigate(['/business-banking']);
    } else {
      // this.router.navigate(['/second-director-details']);
      this.router.navigate(['/business-banking']);
    }
  }

  public disableForm() {
    return ($('#thumbnail-container-ic-f').attr('src') === '' || $('#thumbnail-container-ic-b').attr('src') === '')
   
  }
}
